<template>
    <div>
        <div class="text-center">
            <h3 class="text-uppercase font-weight-bold mb-0" v-if="program.graduate == 0">
                {{$t('transcript.provisionalTranscript')}}
            </h3>
            <p><small class="font-weight-bold">{{$t('transcript.validSeal')}}</small></p>
            <p class="mb-0" v-if="!local_transcripts"><strong>{{program.code}}</strong></p>
            <p class="mb-0" v-if="local_transcripts && program.program_code == 'MSc' && student.partner_code == 'SBS'"><strong>{{$t('transcript.mastersDegreeProgram')}}</strong></p>
            <p class="mb-0" v-else-if="local_transcripts && program.program_code == 'BSC' && student.partner_code == 'SBS' && program.program_type != 'CAP Program'"><strong>{{$t('transcript.bachelorsDegreeProgram')}}</strong></p>
            <p class="mb-0" v-else-if="local_transcripts && program.program_code == 'MBA' && student.partner_code == 'SBS'"><strong>{{$t('transcript.furtherEducationProgram')}}</strong></p>
            <p class="mb-0" v-else-if="local_transcripts && program.program_code == 'EMBA' && student.partner_code == 'SBS'"><strong>{{$t('transcript.furtherEducationProgram')}}</strong></p>
            <p class="mb-0"><strong>{{program.type}}</strong></p>
            <p class="mb-0" v-if="!is_mabr && program.program_type != 'CAP Program'">{{$t('transcript.major')}} {{program.title}}</p>
            <p class="mb-0" v-if="program.specialization">{{$t('transcript.specialization')}} {{program.specialization}}</p>
            <p class="mb-0 font-weight-bold">
                <small class="font-weight-normal">{{$t('transcript.academicYear')}}<br></small>
                {{ academic_year }}</p>
        </div>

        <div class="my-3">
            <table id="student-detials-table">
                <tr>
                    <td>{{$t('transcript.studentName')}}</td>
                    <th>{{student.name}}</th>
                </tr>
                <tr v-if="student.matriculation_number != null">
                    <td>{{$t('transcript.studentMatriculationNumber')}}</td>
                    <th>{{student.student_number}} / {{student.matriculation_number}}</th>
                </tr>
                <tr v-else>
                    <td>{{$t('transcript.studentNumber')}}</td>
                    <th>{{student.student_number}}</th>
                </tr>
                <tr>
                    <td>{{$t('transcript.birthDate')}}</td>
                    <th>{{student.birth_date}}</th>
                </tr>
                <tr>
                    <td>{{$t('transcript.birthPlace')}}</td>
                    <th>{{student.birth_place}}</th>
                </tr>
                <tr>
                    <td>{{$t('transcript.reportDate')}}</td>
                    <th>{{report_date}}</th>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['student', 'program', 'report_date', 'academic_year', 'is_mabr', 'local_gpa', 'local_transcripts']
    }

</script>
